import { DeprecatedTokens } from '@visikon/spine/src/styles/tokens/deprecated-tokens';
import styled from 'styled-components';

export const ScreenHeaderWrapper = styled.div`
  margin-top: 0px;
  padding-top: 22px;
  display: flex;
  gap: 18px;
  align-items: center;
`;

export const ScreenHeader = styled.h1`
  color: ${DeprecatedTokens.dark};
  font-size: 1.6em;
  font-weight: 600;
  line-height: 1.5;

  @media all and (max-width: ${DeprecatedTokens.breakPoint}) {
    font-size: 1.25em;
  }
`;
export const SubHeader = styled.p`
  line-height: 1.5;
  margin-top: 0.8em;
  width: 75%;

  @media all and (max-width: ${DeprecatedTokens.breakPointMid}) {
    width: 100%;
  }
`;
